import type { Staging } from "@/types/api";
import { create } from "zustand";

interface StagingsAdminUiState {
  rawSearch: string;
  search: string;
  statuses: number[];
  deleting: Staging | null;
  previewing: Staging | null;
  setRawSearch: (v: string) => void;
  setSearch: (v: string) => void;
  setStatuses: (v: number[]) => void;
  setDeleting: (s: Staging | null) => void;
  setPreviewing: (s: Staging | null) => void;
}

export const useStagingsAdminUi = create<StagingsAdminUiState>((set) => ({
  rawSearch: "",
  search: "",
  // Empty means "every status", so the page opens unfiltered.
  statuses: [],
  deleting: null,
  previewing: null,
  setRawSearch: (rawSearch) => set({ rawSearch }),
  setSearch: (search) => set({ search }),
  setStatuses: (statuses) => set({ statuses }),
  setDeleting: (deleting) => set({ deleting }),
  setPreviewing: (previewing) => set({ previewing }),
}));
